export default __webpack_public_path__ + "assets/images/e7ed97d830311dfd2ec2f8d2e71a7da3.svg";